import { parseTenThousandths } from '@shared/utils/moneyArithmetic';
import type { FundAccountPostingsPage } from '../types/fundAccountPostings.types';
import type { StatementLine } from './statementBlocks';
import { sameAmount, sameUnsplit, sameVatRates } from './vatFigures';

export const postingsReconcile = (
    line: StatementLine,
    window: { from: string; to: string },
    page: FundAccountPostingsPage,
): boolean => {
    const pageAmount = parseTenThousandths(page.amount);
    const lineAmount = parseTenThousandths(line.amount);
    return (
        page.trancode === line.key &&
        pageAmount !== null &&
        lineAmount !== null &&
        pageAmount === lineAmount &&
        page.postings === line.postings &&
        sameAmount(page.vat, line.vat) &&
        sameAmount(page.net, line.net) &&
        sameUnsplit(page.unsplit, line.unsplit) &&
        sameVatRates(page.vatRates, line.vatRates) &&
        page.from === window.from &&
        page.to === window.to
    );
};
